import * as React from "react";

interface AnimationContextType {
	isAnimated: boolean;
	setIsAnimated: (isAnimated: boolean) => void;
}

const AnimationContext = React.createContext<AnimationContextType | undefined>(undefined);

export function useAnimation(): AnimationContextType {
	const context = React.useContext(AnimationContext);
	if (context === undefined) {
		throw new Error("useAnimation must be used within an AnimationProvider");
	}
	return context;
}

export function AnimationProvider({ children }: { children: React.ReactNode }): React.JSX.Element {
  const [isAnimated, setIsAnimated] = React.useState(false);

	const value: AnimationContextType = {
		isAnimated,
		setIsAnimated,
	};

	return <AnimationContext.Provider value={value}>{children}</AnimationContext.Provider>;
}
